module.exports = __webpack_public_path__ + "static/media/checkmark.0b740630.svg";